import React from "react";
import { CircularProgress } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { PlanoCardProps } from "./types";
import Button from "../../ui/Button.tsx";
import "../../styles/design-system.css";

const formatCurrency = (value: number) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value);

// Preco ausente vira travessao, nunca R$ 0,00 nem um valor de reserva: o bug
// que originou essa mudanca foi exatamente um numero chumbado no frontend que
// divergia do que a ASAAS cobrava.
const formatCurrencyOuVazio = (value: number | null) =>
  value === null || value === undefined ? "—" : formatCurrency(value);

const PlanoCard: React.FC<PlanoCardProps> = ({
  titulo,
  precoMensal,
  precoAnual,
  valorMensalEquivalente,
  funcionalidades,
  recomendacao = false,
  isAnnual,
  onAssinar,
  isAtivo = false,
  disabled = false,
  isPlanActive = false,
  isReativacao = false,
  loading = false,
}) => {
  // Botão "plano atual" tem um tratamento visual próprio (fundo translúcido,
  // cursor padrão) — não é um estado de erro/bloqueio, é só informativo, então
  // não usa o dimming genérico de disabled (.ds-btn[disabled]{opacity:.5}).
  const isCurrentPlanButton = disabled && isAtivo;

  return (
    <div className={`ds ds-plan-card ${isAtivo ? "current" : ""}`}>
      {isAtivo && <span className="ds-plan-badge-current current-tag">Seu plano</span>}

      <div className="plan-name">{titulo}</div>
      <div className="plan-price">
        {formatCurrencyOuVazio(isAnnual ? valorMensalEquivalente : precoMensal)}
        <span>/mês</span>
      </div>
      {isAnnual && (
        <div className="plan-annual-info">
          <span className="plan-annual-badge">Economize 15%</span>
          <span>Cobrado anualmente: <strong style={{ color: "var(--ink)" }}>{formatCurrencyOuVazio(precoAnual)}</strong></span>
        </div>
      )}

      <ul>
        {funcionalidades.map((item, index) => (
          <li key={index}>
            <CheckIcon />
            <span>{item}</span>
          </li>
        ))}
      </ul>

      <Button
        variant="primary"
        onClick={onAssinar}
        disabled={disabled || loading}
        className={isCurrentPlanButton ? "ds-btn-current-plan" : ""}
        style={{ width: "100%" }}
      >
        {loading ? (
          <CircularProgress size={18} color="inherit" />
        ) : disabled ? "Plano atual" : isReativacao ? "Reativar plano" : isPlanActive ? "Mudar plano" : "Assinar plano"}
      </Button>
    </div>
  );
};

export default PlanoCard;
